import * as React from 'react';

type BeforeUnloadProps = {
  children: React.ReactNode;
  active: boolean;
  // eslint-disable-next-line react/require-default-props
  onBeforeUnload?: (event: React.SyntheticEvent) => any;
};

class BeforeUnload extends React.Component<BeforeUnloadProps> {
  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = (event: any) => {
    const { onBeforeUnload, active } = this.props;

    if (active) {
      if (onBeforeUnload) {
        onBeforeUnload(event);
      }

      // This seems to be the standard way to handle beforeunload.
      const confirmationMessage =
        'Unsaved changes you have made will be lost. Do you wish to continue?';
      event.returnValue = confirmationMessage; // eslint-disable-line no-param-reassign
      return confirmationMessage;
    }

    return null;
  };

  render() {
    return this.props.children;
  }
}

export default BeforeUnload;
